import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option"]
  static values = {
    fieldName: String,
    multiple: Boolean
  }

  connect() {
    this.selectedValues = []
  }

  open(event) {
    event.preventDefault()

    // Get the dialog ID from the trigger button
    const dialogId = event.currentTarget.dataset.selectionDialogId
    if (!dialogId) return

    const dialog = document.getElementById(dialogId)
    if (!dialog) return

    dialog.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.element.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  select(event) {
    const input = event.target
    const label = input.closest("label")

    if (this.multipleValue) {
      if (input.checked) {
        label.classList.add("bg-red-50", "border-red-300")
      } else {
        label.classList.remove("bg-red-50", "border-red-300")
      }
    } else {
      // Single select - remove highlight from all, add to selected
      this.optionTargets.forEach(opt => {
        opt.classList.remove("bg-red-50", "border-red-300")
      })
      label.classList.add("bg-red-50", "border-red-300")
    }
  }

  confirm() {
    const selectedInputs = this.element.querySelectorAll(`input[name="${this.element.id}_selection"]:checked`)
    const values = Array.from(selectedInputs).map(input => input.value)
    const ids = Array.from(selectedInputs).map(input => input.dataset.id)

    // Find the corresponding hidden input and display element based on field name
    const fieldName = this.fieldNameValue
    let hiddenInputId, displayElementId

    switch(fieldName) {
      case "industry":
        hiddenInputId = "industry-input"
        displayElementId = "industry-display"
        break
      case "occupation":
        hiddenInputId = "occupation-input"
        displayElementId = "occupation-display"
        break
      case "workplace_type":
        hiddenInputId = "workplace-type-input"
        displayElementId = "workplace-type-display"
        break
      case "customer_type":
        hiddenInputId = "customer-type-input"
        displayElementId = "customer-type-display"
        break
      case "management_count":
        hiddenInputId = "management-count-input"
        displayElementId = "management-count-display"
        break
      case "external_company_count":
        hiddenInputId = "external-company-count-input"
        displayElementId = "external-company-count-display"
        break
      case "qualification":
        hiddenInputId = "qualification-input"
        displayElementId = "qualification-display"
        break
      case "software":
        hiddenInputId = "software-input"
        displayElementId = "software-display"
        break
    }

    const hiddenInput = document.getElementById(hiddenInputId)
    const displayElement = document.getElementById(displayElementId)

    // Update hidden input
    if (hiddenInput) {
      if (this.multipleValue) {
        hiddenInput.value = values.join(",")
      } else {
        hiddenInput.value = ids[0] || ""
      }
    }

    // Update display element
    if (displayElement) {
      if (values.length > 0) {
        const badges = values.map(v =>
          `<span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">${v}</span>`
        ).join(" ")
        displayElement.innerHTML = badges
      } else {
        displayElement.innerHTML = '<span class="text-sm text-gray-400">未設定</span>'
      }
    }

    this.close()

    // Dispatch custom event
    this.dispatch("selected", {
      detail: { values, ids, fieldName: this.fieldNameValue }
    })
  }
}
